import { lazy, Suspense } from "react";
import { Navbar } from "@/components/sd/Navbar";
import { Hero } from "@/components/sd/Hero";
import { UspBar } from "@/components/sd/UspBar";
import { Services } from "@/components/sd/Services";
import { CtaBanner } from "@/components/sd/CtaBanner";
import { Coverage } from "@/components/sd/Coverage";
import { OpeningHours } from "@/components/sd/OpeningHours";
import { Footer } from "@/components/sd/Footer";
import { Helmet } from "react-helmet-async";

const Testimonials = lazy(() =>
  import("@/components/sd/Testimonials").then((m) => ({ default: m.Testimonials }))
);
const WhatsAppButton = lazy(() =>
  import("@/components/sd/WhatsAppButton").then((m) => ({ default: m.WhatsAppButton }))
);


const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>S&D Facility Service | Reinigung & Gartenpflege im Murtal</title>
        <meta
          name="description"
          content="Professionelle Reinigung, Gartenpflege, Hochdruckreinigung, Winterdienst und Hausmeisterservice im Murtal. Zuverlässig, pünktlich und persönlich. Gratis Erstbesichtigung anfragen."
        />
        <link rel="canonical" href="https://sd-facility.lovable.app/" />
        
      </Helmet>
      <Navbar />
      <main>
        <Hero />
        <UspBar />
        <Services />
        <CtaBanner />
        <Coverage />
        <Suspense fallback={null}>
          <Testimonials />
        </Suspense>
        <OpeningHours />
      </main>
      <Footer />
      <Suspense fallback={null}>
        <WhatsAppButton />
      </Suspense>
    </div>
  );
};

export default Index;
